import { defineMessages } from 'react-intl';

type MessageKeys =
	| 'betaLabel'
	| 'infoIconLabel'
	| 'atlassianIntelligenceCopyrightShort'
	| 'atlassianIntelligenceCopyright'
	| 'rovoCopyright'
	| 'disclaimerTextUpdated'
	| 'usePageKnowledgeToggleLabel'
	| 'compactFeedbackText';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> = defineMessages({
	betaLabel: {
		id: 'fabric.editor.ai.screens.preview.betaLabel',
		defaultMessage: 'Beta',
		description: 'The label describing the beta status of the Atlassian Intelligence feature',
	},
	infoIconLabel: {
		id: 'fabric.editor.ai.commandPalette.footer.infoIconLabel',
		defaultMessage: 'Information',
		description:
			'Accessible label for the information icon displayed in the footer of the Editor AI command palette.',
	},
	atlassianIntelligenceCopyrightShort: {
		id: 'fabric.editor.ai.commandPalette.footer.atlassianIntelligenceCopyrightShort',
		defaultMessage: 'Powered by AI',
		description:
			'Text to display in the right part of Editor AI command palette footer in short form for AI requests',
	},
	atlassianIntelligenceCopyright: {
		id: 'fabric.editor.ai.commandPalette.footer.atlassianIntelligenceCopyright',
		defaultMessage: 'Powered by Atlassian Intelligence',
		description:
			'Text to display in the right part of Editor AI command palette footer for AI requests',
	},
	rovoCopyright: {
		id: 'fabric.editor.ai.commandPalette.footer.rovoCopyright',
		defaultMessage: 'Rovo',
		description:
			'Text to display in the right part of Editor AI command palette footer for Rovo requests',
	},
	disclaimerTextUpdated: {
		id: 'fabric.editor.ai.commandPalette.footer.disclaimerTextUpdated',
		defaultMessage: 'Uses AI. Verify results.',
		description: 'Text to display in the disclaimer part of Editor AI command palette footer',
	},
	usePageKnowledgeToggleLabel: {
		id: 'fabric.editor.ai.commandPalette.footer.usePageKnowledgeToggleLabel',
		defaultMessage: 'Include knowledge from current page',
		description:
			'Label for the toggle to enable or disable the use of page knowledge in AI requests',
	},
	compactFeedbackText: {
		id: 'fabric.editor.ai.screens.preview.compactFeedbackText',
		defaultMessage: 'Helpful?',
		description:
			'Label and prompter text to induce users to click neighbouring thumbs up or down feedback buttons',
	},
});

export default message;
